var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVector = function SvgVector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9L5 5L1 1",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgVector;